var _path, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPercent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9713 1H12.486C12.1792 1 11.8893 1.14089 11.6997 1.38218L1.63557 14.1911C1.37781 14.5192 1.61152 15 2.02873 15H3.51396C3.82083 15 4.1107 14.8591 4.30028 14.6178L14.3644 1.80891C14.6222 1.48085 14.3885 1 13.9713 1Z",
    fill: "#F68C34"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 2.5,
    stroke: "#F68C34",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 2.5,
    stroke: "#F68C34",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPercent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/percent.905dbe3f0bfa804516c7d7223a179aee.svg";